import React, { useContext, useEffect } from "react";
import { getVenueLabels, initialVenueFilter } from "./FilterTypes/VenueFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import MultiVenueList from "components/Picker/VenuePicker/MultiVenueList";

const VenueFilter = () => {
  const title = site.currentEnvironment.functionGroups.venue.singular;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("venue", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getVenueLabels(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedVenues.length > 0,
    reset: () => initialVenueFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedVenues.map(v => v.venueId), b.selectedVenues.map(v => v.venueId))
  });
  useEffect(() => {
    setInitialValue("venue", initialVenueFilter);
  }, []);

  const [selectedVenues, setSelectedVenues] = React.useState<server.dto.VenueSmall[]>(initialVenueFilter.selectedVenues);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedVenues(getValue("venue").selectedVenues);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("venue", { selectedVenues });
    setPopupOpen(false);
  };

  if (!site.currentEnvironment.functionGroups.venue.enabled) {
    return <></>;
  }

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiVenueList
        value={selectedVenues}
        onChange={setSelectedVenues}
      />
    </MultiPickerFilterPopup>
  </div>
};

export default VenueFilter;
